import { array, string } from "yup";

export const jobOfferValidation = {
  job_position: string().trim().required('Job position is required'),
  company: string().trim().required('Company is required'),
  message: string().trim().required('Additional information is required'),
};

export const serviceValidation = {
  package_type: string().required('Package is required'),
  message: string().trim().required('Website details is required'),
  service_type: array().min(1, 'Select at least one service')
};

export const basicEmailDetailsValidation = {
  name: string().trim().required('Name is required'),
  email: string().trim().email('Invalid email').required('Email is required'),
};